import { useEffect, useState } from "react";
import LoginView from "./views/LoginView";
import OrdersView from "./views/OrdersView";
import { fetchSession } from "./api";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSession()
      .then((sessionUser) => {
        setUser(sessionUser);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="app-shell">
        <div className="loader">Ładowanie...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginView onAuthenticated={setUser} />;
  }

  return (
    <OrdersView
      user={user}
      onLogout={() => setUser(null)}
      onUserUpdate={setUser}
    />
  );
}

export default App;
